import { render, staticRenderFns } from "./settingEdit.vue?vue&type=template&id=f9891a2c&scoped=true"
import script from "./settingEdit.vue?vue&type=script&lang=js"
export * from "./settingEdit.vue?vue&type=script&lang=js"
import style0 from "./settingEdit.vue?vue&type=style&index=0&id=f9891a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9891a2c",
  null
  
)

export default component.exports